import React from 'react'
import {Button} from './index'
import useTranslation from '../../translation/hook'

export default function UICardColor({state, methods,...props}){
    const {cardColor, cardMaterial} = state
    const {selectMaterialColor} = methods
    const t = useTranslation()
    
    
    return (
        <div className="uiPanel">
            <div className="title">{t("site_pages_shop_app_select_color")}</div>
            <div className="uiColorsRow">
                {cardMaterial.colors.map(color => (
                    <Button key={color.hex}
                            active={cardColor.name === color.name}
                            onClick={() => selectMaterialColor(color.name)}
                            background={color.hex}/>)
                )}
            </div>
        </div>
    )
}
